import { render, staticRenderFns } from "./PublishCollection.vue?vue&type=template&id=50fc55c6&scoped=true"
import script from "./PublishCollection.vue?vue&type=script&lang=js"
export * from "./PublishCollection.vue?vue&type=script&lang=js"
import style0 from "./PublishCollection.vue?vue&type=style&index=0&id=50fc55c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc55c6",
  null
  
)

export default component.exports